import mail from "../../../assets/gmail.svg";
import outlook from "../../../assets/outlook.svg";
import email from "../../../assets/email.svg";
import drive from "../../../assets/drive.svg";
import telematel from "../../../assets/telematel.svg";
import dropbox from "../../../assets/droopbox.svg";
import whatsApp from "../../../assets/whatsappIcon.svg";  
import esPublico from "../../../assets/WhiteGestionaEsPublicoCircle.svg";
import googleSheets from "../../../assets/excelCircle.svg";
import xml from "../../../assets/XmlsCircle.svg";
import stripe from "../../../assets/WhiteStripeCircle.svg";
import odoo from "../../../assets/WhiteOddoCircle.svg";
import wolters from "../../../assets/wolters-icon.svg";
import holded from "../../../assets/WhiteHoldedCircle.svg";
import agencyTribut from "../../../assets/agencia.svg";
import acrobat from "../../../assets/acrobat.svg";
import ftp from "../../../assets/WhiteFTPCircle.svg";
import onedrive from "../../../assets/oneDriveCircle.svg";
import sharepoint from "../../../assets/sharePointCircle.svg";
import hubspot from "../../../assets/HubSportCircleWhite.svg";
import emailRecurrent from "../../../assets/emailRecurrente.svg";
import fichaje from "../../../assets/fichajeRecurrente.svg";
import emailDocIcon from "../../../assets/emailDocIcon.svg";
import chatGPTIcon from "../../../assets/chatGPTForAutomate.svg"
import linkedInIcon from "../../../assets/linkedInIcon.svg"
import justCallIcon from "../../../assets/justCallIcon.svg"
import sendDiferentMailIcon from "../../../assets/sendDiferentMailIcon.svg"
import googleMapsIcon from "../../../assets/googleMapsIcon.svg"
import circleWhiteIcon from "../../../assets/circleWhiteIcon.svg"
import slackIcon from "../../../assets/slackIcon.svg"
import googleCalendar from "../../../assets/googleCalendar.svg"
import googleMeetIcon from "../../../assets/googleMeetIcon.svg"
import microsoftTeamsIcon from "../../../assets/microsoftTeamsIcon.svg"
import zyteApiIcon from "../../../assets/zyteApiIcon.svg"
import brightData from "../../../assets/brightData.svg"
import perfios from "../../../assets/perfios.svg"
import CVScraper from "../../../assets/CVScraper.svg"
import shipOverseas from "../../../assets/shipOverseas.svg"
import DHL from "../../../assets/DHL.svg"
import fedEx from "../../../assets/fedEx.svg"
import shopify from "../../../assets/shopify.svg"
import { useTranslation } from "react-i18next";
export const AutomateDataComponent = () => {
  
const [t] = useTranslation('Automate')
 return [
  {
    id: 1,
    automateName: t('uploadYourGmailDocuments'),
    image: mail,
    contactType: "example@gmail.com",
    type: "Gmail",
    role: "input",
    available: true,
    category: t('Import'),
    description: t('importWithAdvanceFilters'),
  },
  {
    id: 2,
    automateName: t('uploadYourOutlookDocuments'),
    image: outlook,
    contactType: "example@gmail.com",
    type: "Outlook",
    role: "input",
    available: true,
    category: t('Import'),
    description: t('extractFiles'),
  },
  {
    id: 22,
    automateName: 'Sube tus documentos de Email',
    image: emailDocIcon,
    contactType: "example@gmail.com",
    type: "SMTP",
    role: "input",
    available: true,
    category: t('Import'),
    description: 'Extra correos automáticamente',
  },
  {
    id: 3,
    automateName: t('uploadYourGoogleDriveDocuments'),
    image: drive,
    contactType: "example@gmail.com",
    type: "Google Drive",
    role: "input",
    available: true,
    category: t('Import'),
    description: t('filterAndImportCloud'),
  },
  {
    id: 5,
    automateName: t('receiveFilesFromWhatsapp'),
    image: whatsApp,  
    contactType: "+00000000",
    type: "WhatsApp",
    role: "input",
    available: true,
    category: t('Import'),
    description: t('importFilesViaWhatsapp'),
  },
  {
    id: 18,
    automateName: t('automateTelematel'),
    image: telematel,
    contactType: t('directToTelematel'),
    type: "Telematel",
    role: "output",
    available: true,
    category: t('ERP'),
    description: t('syncDataTelematel'),
  },

  {
    id: 7,
    automateName: t('updateGoogleSheets'),
    image: googleSheets,
    contactType: t('sheetTitle'),
    type: "Google Sheets",
    role: "output",
    available: true,
    category: t('Files'),
    description: t('exportDataSpreadSheet'),
  },
  {
    id: 16,
    automateName: t('exportToYourFtpServer'),
    image: ftp,
    contactType: "682",
    type: "FTP",
    role: "output",
    available: true,
    category: t('ERP'),
    description: t('filterAndExportCloud'),
  },
  {
    id: 8,
    automateName: t('generateXmlFiles'),
    image: xml,
    contactType: "example@gmail.com",
    type: "XML",
    role: "output",
    available: true,
    category: t('Files'),
    description: t('convertDataIntoXml'),
  },
  {
    id: 11,
    automateName: t('antiFraudLaw'),
    image: agencyTribut,
    contactType: "example@gmail.com ",
    type: "Agencia Tributaria",
    role: "output",
    available: true,
    category: t('PublicAdministration'),
    description: t('exportTaxAgencyPortal'),
  },
  {
    id: 9,
    automateName: t('exportToOdoo'),
    image: odoo,
    contactType: "example@gmail.com ",
    type: "Odoo",
    role: "output",
    available: true,
    category: t('ERP'),
    description: t('sendDataAccountingAdministrative'),
  },
  {
    id: 10,
    automateName: t('exportWoltersA3'),
    image: wolters,
    contactType: "example@gmail.com ",
    type: "Wolters",
    role: "output",
    available: true,
    category: t('ERP'),
    description: t('connectToWolters'),
  },

  {
    id: 12,
    automateName: t('whatsappMessages'),
    image: whatsApp,
    contactType: "+00000000",
    type: t('whatsAppNotifications'),
    role: "output",
    available: true,
    category: t('Communications'),
    description: t('sendNotificationViaWhatsapp'),
  },
  {
    id: 14,
    automateName: t('connectToHolded'),
    image: holded,
    contactType: "+00000000",
    type: "Holded",
    role: "output",
    available: true,
    category: t('ERP'),
    description: t('syncInformationBillingAccounting'),
  },
  {
    id: 6,
    automateName: t('automateEsPublico'),
    image: esPublico,
    contactType: "example@gmail.com",
    type: "esPúblico Gestiona",
    role: "output",
    available: false,
    category: t('PublicAdministration'),
    description: t('integrationStreamline'),
  },
  {
    id: 17,
    automateName: t('uploadDocumentsOneDrive'),
    image: onedrive,
    contactType: "+00000000",
    type: "One Drive",
    role: "input",
    available: true,
    category: t('Import'),
    description: t('filterAndImportCloud'),
  },
  {
    id: 4,
    automateName: t('uploadYourDropboxDocuments'),
    image: dropbox,
    contactType: "example@gmail.com",
    type: "Dropbox",
    role: "input",
    available: false,
    category: t('Import'),
    description: t('filterAndImportCloud'),
  },
  {
    id: 13,
    automateName: t('processPaymentsStripe'),
    image: stripe,
    contactType: "+00000000",
    type: "Stripe",
    role: "output",
    available: false,
    category: t('Fintech'),
    description: t('automateCollectionsAndPayments'),
  },
  {
    id: 15,
    automateName: t('generatePdfFiles'),
    image: acrobat,
    contactType: "+00000000",
    type: "Acrobat",
    role: "output",
    available: false,
    category: t('Files'),
    description: t('createDocumentsPdf'),
  },
  {
    id: 16,
    automateName: t('uploadSharepointDocuments'),
    image: sharepoint,
    contactType: "+00000000",
    type: "Sharepoint",
    role: "input",
    available: false,
    category: t('Import'),
    description: t('importOrganizeFiles'),
  },

  {
    id: 23,
    automateName: t('exportHubspot'),
    image: hubspot,
    contactType: "+00000000",
    type: "HubSpot",
    role: "output",
    available: false,
    category: t('ERP'),
    description: t('automateDataForMarketingCrm'),
  },
  {
    id: 18,
    automateName: t('sendRecurringEmail'),
    image: emailRecurrent,
    contactType: "+00000000",
    type: t('recurringEmail'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('scheduleAutomaticEmails'),
  },
  {
    id: 19,
    automateName: t('hrTimeClockSystem'),
    image: fichaje,
    contactType: "+00000000",
    type: t('hrSignin'),
    role: "output",
    available: false,
    category: t('HR'),
    description: t('configureAndManageEmployeeTime'),
  },
    {
    id: 24,
    automateName: 'Nombre de la automatizacion',
    image: email,
    contactType: "+00000000",
    type: t('ReplyToEmails'),
    role: "output",
    available: false,
    category: t('Import'),
    description: t('ReplyToEmails'),
  },
    {
    id: 25,
    automateName: 'Nombre de la automatizacion',
    image: chatGPTIcon,
    contactType: "+00000000",
    type: t('ChatGPT'),
    role: "output",
    available: false,
    category: t('Import'),
    description: t('ChatGPT'),
  },
    {
    id: 26,
    automateName: t('LinkedInContactsAPI'),
    image: linkedInIcon,
    contactType: "+00000000",
    type: t('LinkedIn'),
    role: "output",
    available: false,
    category: t('CRM'),
    description: t('SyncProfessionalContactsFromLinkedIn'),
  },
    {
    id: 27,
    automateName: 'Nombre de la automatizacion',
    image: justCallIcon,
    contactType: "+00000000",
    type: t('JustCall'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('JustCallAPIPlatformForIntegratedCalls'),
  },
   {
    id: 28,
    automateName: t('exportHubspot'),
    image: hubspot,
    contactType: "+00000000",
    type: "HubSpot",
    role: "output",
    available: false,
    category: t('CRM'),
    description: t('automateDataForMarketingCrm'),
  },
     {
    id: 29,
    automateName: 'Nombre de la automatizacion',
    image: sendDiferentMailIcon,
    contactType: "+00000000",
    type: t('differentEmailProviders'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('SendingEmailsFromDifferentProviders'),
  },
       {
    id: 30,
    automateName: 'Nombre de la automatizacion',
    image: googleMapsIcon,
    contactType: "+00000000",
    type: t('GoogleMaps'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('GoogleMapsAddLocations'),
  },
         {
    id: 31,
    automateName: t('Trello'),
    image: circleWhiteIcon,
    contactType: "+00000000",
    type: t('Trello'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('SyncProfessionalContactsFromLinkedIn'),
  },
         {
    id: 32,
    automateName: t('Slack'),
    image: slackIcon,
    contactType: "+00000000",
    type: t('Slack'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('SyncProfessionalContactsFromLinkedIn'),
  },
         {
    id: 33,
    automateName: t('MicrosoftList'),
    image: circleWhiteIcon,
    contactType: "+00000000",
    type: t('MicrosoftList'),
    role: "output",
    available: false,
    category: t('Communications'),
    description: t('SyncProfessionalContactsFromLinkedIn'),
  },
           {
    id: 34,
    automateName: 'Nombre de la automatizacion',
    image: googleCalendar,
    contactType: "+00000000",
    type: t('googleCalendar'),
    role: "output",
    available: false,
    category: t('Meetings'),
    description: t('GoogleCalendarAddsEvents'),
  },
           {
    id: 35,
    automateName: 'Nombre de la automatizacion',
    image: googleMeetIcon,
    contactType: "+00000000",
    type: t('googleMeet'),
    role: "output",
    available: false,
    category: t('Meetings'),
    description: t('GoogleMeetAddsEvents'),
  },
           {
    id: 36,
    automateName: 'Nombre de la automatizacion',
    image: microsoftTeamsIcon,
    contactType: "+00000000",
    type: t('microsoftTeams'),
    role: "output",
    available: false,
    category: t('Meetings'),
    description: t('MicrosoftTeamsAddsEvents'),
  },
             {
    id: 37,
    automateName: 'Nombre de la automatizacion',
    image: zyteApiIcon,
    contactType: "+00000000",
    type: 'ZyteAPI',
    role: "output",
    available: false,
    category: t('AI'),
    description: t('ZyteAPIScraping'),
  },
             {
    id: 38,
    automateName: 'Nombre de la automatizacion',
    image: brightData,
    contactType: "+00000000",
    type: 'brightData',
    role: "output",
    available: false,
    category: t('AI'),
    description: t('BrightDataGoogleSearchAPI'),
  },
   {
    id: 39,
    automateName: 'Nombre de la automatizacion',
    image: perfios,
    contactType: "+00000000",
    type: 'perfios',
    role: "output",
    available: false,
    category: t('AI'),
    description: t('PerfiosLendingAPIs'),
  },
   {
    id: 40,
    automateName: 'Nombre de la automatizacion',
    image: CVScraper,
    contactType: "+00000000",
    type: 'CVScraper',
    role: "output",
    available: false,
    category: t('AI'),
    description: t('CVScraper'),
  },
  {
    id: 41,
    automateName: 'Nombre de la automatizacion',
    image: CVScraper,
    contactType: "+00000000",
    type: 'CVScraper',
    role: "output",
    available: false,
    category: t('HR'),
    description: t('CVScraper'),
  },
{
    id: 42,
    automateName: t('exportToYourFtpServer'),
    image: ftp,
    contactType: "682",
    type: "FTP",
    role: "output",
    available: false,
    category: t('Logistics'),
    description: t('filterAndExportCloud'),
  },

  {
    id: 43,
    automateName: 'Nombre de la automatizacion',
    image: shipOverseas,
    contactType: "+00000000",
    type: 'shipOverseasAPI',
    role: "output",
    available: false,
    category: t('Logistics'),
    description: t('shipOverseasAPI'),
  },

  {
    id: 44,
    automateName: 'Nombre de la automatizacion',
    image: DHL,
    contactType: "+00000000",
    type: 'DHL',
    role: "output",
    available: false,
    category: t('Logistics'),
    description: t('DHL'),
  },

  {
    id: 45,
    automateName: 'Nombre de la automatizacion',
    image: fedEx,
    contactType: "+00000000",
    type: 'fedEx',
    role: "output",
    available: false,
    category: t('Logistics'),
    description: t('FedEx'),
  },
  {
    id: 46,
    automateName: 'Nombre de la automatizacion',
    image: perfios,
    contactType: "+00000000",
    type: 'perfios',
    role: "output",
    available: false,
    category: t('Fintech'),
    description: t('ProfilesLendingAPIsEvaluateFinancingOffers'),
  },
  {
    id: 47,
    automateName: 'Nombre de la automatizacion',
    image: shopify,
    contactType: "+00000000",
    type: 'shopify',
    role: "output",
    available: false,
    category: t('Ecommerce'),
    description: t('Shopify'),
  },


];
}
export default AutomateDataComponent